// data/fonts.js

export const fonts = [
  {
    id: "cps-momentum",
    family: "CPS Momentum",
    styles: [
      {
        id: "regular",
        name: "Regular",
        family: "CPS Momentum Regular",
      },
      {
        id: "black",
        name: "Black",
        family: "CPS Momentum Black",
      },
      {
        id: "italic",
        name: "Italic",
        family: "CPS Momentum Italic",
      },
    ],
  },
  {
    id: "cps-semillas",
    family: "CPS Semillas",
    styles: [
      {
        id: "smooth",
        name: "Smooth",
        family: "CPS Semillas Smooth",
      },
      {
        id: "sprinkle",
        name: "Sprinkle",
        family: "CPS Semillas Sprinkle",
      },
      {
        id: "scatter",
        name: "Scatter",
        family: "CPS Semillas Scatter",
      },
    ],
  },
  {
    id: "cps-mechanick",
    family: "CPS Mechanick",
    styles: [
      {
        id: "regular",
        name: "Regular",
        family: "CPS Mechanick Regular",
      },
    ],
  },
];